export const NEW_ARTWORK_ID = 'new';
export const LOCATIONS_ARTWORK_ID = 1;
export const NO_CUSTOMISATION_ARTWORK_ID = 'none';
export const EMPTY_ARTWORK_ID = 'no-state';
export const HAVE_MY_LOGO = 'haveMyLogo';
export const LOGO_EXIST = 'logoExist';
